export default "__VITE_ASSET__f4a92872__"